import { FilterType } from "../../apiclients/api/types/FilterType";

export const DEFAULT_COLUMNS_LIST = [
  { key: "displayName", columnKey: "UserName" },
  { key: "accountStatusName", columnKey: "UserAccountStatusName" },
  { key: "mail", columnKey: "UserEmailAddress" },
  { key: "employeeTitle", columnKey: "EmployeeTitle" },
  { key: "lastLoggedInDateTime", columnKey: "LastLoggedInDateTime" },
  { key: "operationManager", columnKey: "OperationManager" },
  { key: "projectAdministrator", columnKey: "ProjectAdministrator" },
  { key: "projectDirector", columnKey: "ProjectDirector" },
  { key: "projectManager", columnKey: "ProjectManager" },
  { key: "accountOwner", columnKey: "AccountOwner" },
  { key: "allProjectsViewer", columnKey: "AllProjectsViewer" },
  {
    key: "employeeHomeOrganizationName",
    columnKey: "EmployeeHomeOrganizationName",
  },
  { key: "employeeHomeCompanyName", columnKey: "EmployeeHomeCompanyName" },
];

export const OPTIONAL_COLUMNS_LIST: (typeof DEFAULT_COLUMNS_LIST)[number][] =
  [];

export const USER_ROLES: { [key: string]: number } = {
  OperationManager: 1,
  ProjectAdministrator: 2,
  ProjectDirector: 3,
  ProjectManager: 4,
  AccountOwner: 5,
  AllProjectsViewer: 7,
};

export const EDITABLE_CELL = ["employeeTitle"];

export const FROZEN_COLUMN = DEFAULT_COLUMNS_LIST[0].key;

export const FILTER_TYPE: { [key: string]: FilterType } = {
  UserName: FilterType.AutoComplete,
  UserEmailAddress: FilterType.AutoComplete,
  UserAccountStatusName: FilterType.AutoComplete,
  EmployeeTitle: FilterType.AutoComplete,
  EmployeeHomeOrganizationName: FilterType.AutoComplete,
  EmployeeHomeCompanyName: FilterType.AutoComplete,
};

export enum RoleFilter {
  Checked,
  Unchecked,
}

export const ROLE_FILTER_KEY = "roleId";
